import React, { Component } from 'react';
import { TableHeaderColumn } from '@nurhanna/react-bootstrap-table';
import _ from 'lodash';
import moment from 'moment';
import { FormattedNumber, IntlProvider } from 'react-intl';
import { Glyphicon } from 'react-bootstrap';
import '../assets/css/bootstrap-glyphicons.css';



class AlacrityTable extends Component {


  // eslint-disable-next-line class-methods-use-this,react/sort-comp
  columnTitle(cell) {
    return _.capitalize(cell);
  }

  // eslint-disable-next-line class-methods-use-this
  createProcessingEditor(onUpdate, props) {
    const unsubStatus = ['active', 'trial', 'free', 'inactive', 'suspended', 'action_cancel'];
    if (props.row.id && unsubStatus.includes(_.get(props.row, 'status'))) {
      if (_.get(props.row, 'status') === 'action_cancel') {
        return (
          <button
            type="button"
            className="btn btn-outline-info btn-sm"
            data-toggle="tooltip"
            data-placement="top"
            title="Unsubscribe?"
            onClick={() => props.handleSubmit(_.get(props.row, 'id'), _.startCase(_.get(props.row, props.messageText)))}
          >
            <Glyphicon
              glyph="glyphicon glyphicon-off"
            />
          </button>
        );
      }
      return (
        <div>
          <button
            type="button"
            className="btn btn-outline-secondary btn-sm"
            data-toggle="tooltip"
            data-placement="top"
            title="Processing.."
          >
            <Glyphicon
              glyphicon-align-center="true"
              glyph="glyphicon glyphicon-hourglass"
            />
          </button>
        </div>
      );
    }
    return (
      <button
        disabled
        type="button"
        className="btn btn-outline-danger btn-sm"
        data-toggle="tooltip"
        data-placement="top"
        title="Service already unsubcribe"
      >
        <Glyphicon
          glyph="glyphicon glyphicon-ban-circle"
        />
      </button>
    );
  }

  // eslint-disable-next-line class-methods-use-this
  formattedData(cell, row, props) {
    let value = _.get(row, props.path);
    switch (props.dataType) {
      case 'date': {
        const _start = moment(cell).locale('en');

        return moment.utc(_start).format('YYYY-MM-DD HH:mm:ss');
      }
      case 'money': {
        value = (
          <IntlProvider locale="en">
            <FormattedNumber
              value={value}
              maximumFractionDigits={props.ignoreDecimal ? 0 : 3}
            /* eslint-disable-next-line react/style-prop-object */
              style="currency"
              currencyDisplay="symbol"
              currency={_.get(row, props.currencyPath)}
            />
          </IntlProvider>
        );

        return (
          <div className="div-centered-text">
            <span title="Currency">
              {' '}
              {value || props.defaultValue}
              {' '}
            </span>
          </div>
        );
      }
      default:
        return (_.upperFirst((cell)));
    }
  }

  // eslint-disable-next-line class-methods-use-this
  showData(cell, row, props) {
    const unsubStatus = ['created', 'failed', 'deleted', 'cancelled', 'purged'];
    // let unsubStatus_text = [ "created", "deleted", "cancelled", "purged" ];
    // removed "cancelled" from unsubStatus_text
    // eslint-disable-next-line camelcase
    const unsubStatus_text = ['created', 'deleted', 'purged'];

    if (!cell) {
      if (!_.isEmpty(props.path)) {
        const splitStr = props.path;
        const arr = splitStr.split('.');

        return _.upperFirst(_.get(row[arr[0]], arr[1]));
      }
      if (props.dataFormat === 'button') {
        if (unsubStatus.includes(_.get(row, 'status'))) {
          return (
            <button
              disabled
              type="button"
              className="btn btn-outline-danger btn-sm"
              data-toggle="tooltip"
              data-placement="top"
              title="Service already unsubscribed"
            >
              <Glyphicon
                glyph="glyphicon glyphicon-ban-circle"
              />
            </button>
          );
        }
        return (
          <button
            type="button"
            className="btn btn-outline-info btn-sm"
            data-toggle="tooltip"
            data-placement="top"
            title="Unsubscribe?"
            onClick={() => props.handleSubmit(_.get(row, 'id'), _.upperFirst(_.get(row, props.messageText)))}
          >
            <Glyphicon
              glyph="glyphicon glyphicon-off"
            />
          </button>
        );
      }
    } else {
      if (props.dataFormat === 'subscription_status') {
        // eslint-disable-next-line camelcase
        if (unsubStatus_text.includes(_.get(row, 'status'))) {
          return ('DELETED');
        }
        return (cell);
      }
      return _.upperFirst(_.get(cell, props.formatExtraData));
    }
  }

  setText(text) {
    const { t } = this.props;

    return t(text);
  }



  renderTableColumns() {
    const { i18n = [] } = this.props;
    return this.columns.map((column) => (
      <TableHeaderColumn

        dataAlign={i18n.language === 'ar' ? 'right' : 'left'}
        dataField={column.path}
        dataFormat={_.isNil(column.dataFormat) ? this.formattedData : this.showData}
        dataSort={column.sort}
        formatExtraData={column}
        isKey={column.isKey}
        key={column.path ? column.path : column.title}
        filter={column.filter}
        hidden={column.hidden}
        width={column.width}
        csvFormat={this.renderCsvCustom}
        csvFormatExtraData={column}
        csvHeader={column.title}
        thStyle={{ overflow: 'visible', wordBreak: 'break-word' }}
        className={column.className}
        row={column.row}
        rowSpan={column.rowSpan}
        colSpan={column.colSpan}
        customEditor={column.customEditor}
        columnTitle={this.columnTitle}
        tdStyle={{ whiteSpace: 'normal', wordBreak: 'break-word' }}

      >
        {this.setText(column.title)}
      </TableHeaderColumn>
    ));
  }
}

export default AlacrityTable;
